import useOrderBy from '@/lib/hooks/useOrderBy'

export default (valueProp, setterProp) => (Component) =>
  function withOrderBy({...props}) {
    const [value, setter] = useOrderBy()
    props[valueProp] = value
    props[setterProp] = setter
    return <Component {...props} />
  }
